import Vue from 'vue'
import asyncComputed from 'vue-async-computed'

export default Vue.use(asyncComputed)
